import { render } from "./WorkflowList.vue?vue&type=template&id=890e98c6&scoped=true"
import script from "./WorkflowList.vue?vue&type=script&lang=js"
export * from "./WorkflowList.vue?vue&type=script&lang=js"

import "./WorkflowList.vue?vue&type=style&index=0&id=890e98c6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-890e98c6"],['__file',"src/views/h5/common/approval/WorkflowList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "890e98c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('890e98c6', __exports__)) {
    api.reload('890e98c6', __exports__)
  }
  
  module.hot.accept("./WorkflowList.vue?vue&type=template&id=890e98c6&scoped=true", () => {
    api.rerender('890e98c6', render)
  })

}


export default __exports__